export default __webpack_public_path__ + "static/media/fortune-16.320fa51f.png";